import * as angular from 'angular';

let IssueFormCustomFieldCheckboxComponent = {
    selector: 'imIssueFormCustomFieldCheckbox',
    template: `
        <dl class="form-element">
            <dt>
                <label>{{ $ctrl.field.label }}</label>
            </dt>
            <dd>
                <div ng-repeat="(index, checkbox) in $ctrl.checkboxes">
                    <input
                        type="checkbox"
                        ng-model="checkbox.checked"
                        ng-change="$ctrl.updateFieldValue()"
                        id="custom-field-checkbox-{{ $ctrl.field.id }}-{{ index }}"
                        name="{{ $ctrl.field.label }}"
                        style="width: 30px;"/>
                    <label for="custom-field-checkbox-{{ $ctrl.field.id }}-{{ index }}">{{ checkbox.label }}</label>
                </div>
            </dd>
        </dl>
`,
    bindings: {
        isFullWidth: '<', // boolean
        field: '=',
    },
    controller: class IssueFormCustomFieldCheckboxController {

        public checkboxes = {};
        public field;

        private $scope;

        constructor($scope) {
            this.$scope = $scope;

            if (this.field.field_options) {
                this.field.field_options.forEach((field_option) => {
                    this.checkboxes[field_option] = {
                        checked:
                            this.field.value && this.field.value.includes(field_option),
                        label: field_option,
                    };
                });
            }
        }

        updateFieldValue() {
            let checked_values = [];
            for (let field_option in this.checkboxes) {
                if (this.checkboxes[field_option].checked) {
                    checked_values.push(this.checkboxes[field_option].label);
                }
            }
            this.field.value = checked_values;
        }
    }
};

angular
    .module('app')
    .component(IssueFormCustomFieldCheckboxComponent.selector, IssueFormCustomFieldCheckboxComponent);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/custom_fields/issue-form-custom-field-checkbox.component.ts